import {
    CheckCouponRequest,
    Coupon,
    ICouponRepository,
} from '@lib/domain/coupon';
import { HTTPService } from '../HTTPService/HTTPService';

interface IDependencies {
    httpService: HTTPService;
}

export class CouponRepository implements ICouponRepository {
    private httpService: HTTPService;

    constructor({ httpService }: IDependencies) {
        this.httpService = httpService;
    }

    async checkCouponByCode(
        payload: CheckCouponRequest,
    ): Promise<Coupon | null> {
        const resp = await this.httpService.get({
            url: '/coupon/code',
            data: payload,
        });
        if (resp && resp.data) {
            return resp.data;
        }
        return null;
    }

    async removeCoupon(code: string, orderId?: string): Promise<Coupon | null> {
        const resp = await this.httpService.post({
            url: '/coupon/remove',
            data: { coupon_code: code, order_summary_id: orderId },
        });
        if (resp && resp.data) {
            return resp.data;
        }
        return null;
    }
}
